import SysLog from './SysLog';

export default SysLog;